module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"background":"Background","none":"None","gaia_dr2":"Gaia DR2","eso_milky_way_panoram":"ESO Milky Way Panoram","mitaka_campus_by_satoshi_kawanomoto":"Mitaka Campus by Satoshi Kawanomoto","fade":"Fade"},"ja":{"background":"背景","none":"なし","gaia_dr2":"Gaia DR2","eso_milky_way_panoram":"天の川（ESOのデータ）","mitaka_campus_by_satoshi_kawanomoto":"国立天文台三鷹グラウンド（by 川野元聡）","fade":"拡大時に薄くする"}}')
  delete Component.options._Ctor
}
